"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toQueryString = void 0;
var toQueryString = function (params) {
    if (params === void 0) { params = {}; }
    var query = {};
    Object.keys(params).forEach(function (key) {
        if (params[key] != null) {
            query[key] = String(params[key]);
        }
    });
    return new URLSearchParams(query).toString();
};
exports.toQueryString = toQueryString;
//# sourceMappingURL=toQueryString.js.map